import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { GenericContentDetailComponent } from './generic-content-detail/generic-content-detail.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, finalize, Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { PaginationResult } from 'src/app/models/common.response';
import { GenericContentService } from './generic-content.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { IGenericContent } from './igeneric-content';
import { PAGE_SIZE_OPTIONS } from 'src/app/common/constant/constants.type';


@Component({
  selector: 'app-generic-content-list',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './generic-content-list.component.html',
  styleUrl: './generic-content-list.component.scss'
})
export class GenericContentListComponent implements OnInit {

  displayedColumns: string[] = [
    'GenericContentName',
    'action',
  ];
  dataSource = new MatTableDataSource<IGenericContent>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  pagination: PaginationResult;
  genericContentcount: number = 0;
  genericContents$: Observable<IGenericContent[]>;
  genericContentdata: IGenericContent[];
  isLoading: boolean = false;
  isLoadData: boolean;
  searchGenericContent: FormControl = new FormControl();
  searchQuery: string;
  pageSizeOptions = PAGE_SIZE_OPTIONS;


  constructor(
    private _genericContentService: GenericContentService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private translate: TranslateService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this._genericContentService.pagination$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((pagination: PaginationResult | null) => {
        if (pagination) {
          this.pagination = pagination;
          this.genericContentcount = this.pagination.rowCount;
        }
      });

    this._genericContentService.genericContetnts$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data) => {
        this.genericContentdata = data;
        this.dataSource = new MatTableDataSource(this.genericContentdata); // Correct initialization
        this.dataSource.paginator = this.paginator;
      });

    this.searchGenericContent.valueChanges.pipe(
      takeUntil(this._unsubscribeAll),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((query) => {
        return this._genericContentService.getAllGenericContent({
          pageNumber: 0,
          pageSize: this.pagination.pageSize,
          isDescending: false,
          searchValue: query || ''
        }).pipe(
          finalize(() => (this.isLoading = false))
        );
      })
    ).subscribe((response) => {
      if (response && response.result) {
        this.dataSource.data = response.result.genericContentDetails;
        this.genericContentcount = response.result.pagination.rowCount;
      }
    });

  }

  onAddGenericContent() {
    this.dialog.open(GenericContentDetailComponent, {
      width: '700px',
      height: 'auto',
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.refreshGenericContent();
      }
    });
  }

  onUpdateGenericContent(genericContentDetails: IGenericContent) {
    this.dialog.open(GenericContentDetailComponent, {
      width: '600px',
      height: 'auto',
      data:
      {
        genericContent: genericContentDetails,
        isEdit: true
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.refreshGenericContent();
      }
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  refreshGenericContent() {
    const globalSearchValue = this.searchGenericContent?.value?.trim();
    const requestPayload: any = {
      pageNumber: 0,
      pageSize: this.pagination?.pageSize || 100,
      isDescending: false
    };

    if (globalSearchValue) {
      requestPayload.SearchValue = globalSearchValue;
    } else {
      requestPayload.pageNumber = this.pagination?.currentPage || 0;
    }

    this._genericContentService.getAllGenericContent(requestPayload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response) => {
        if (response && response.result) {
          const genericContent = response.result.genericContentDetails;
          this.genericContentdata = genericContent;
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(genericContent);
          } else {
            this.dataSource.data = genericContent;
          }
          this.dataSource.paginator = this.paginator;
          this.genericContentcount = response.result.pagination.rowCount;
          this.pagination = response.result.pagination;
        }
      });

  }

}
